globalThis._env_ = {
  FEED_URL: __FEED_URL__,
  OIDC_URL: __OIDC_URL__,
  OIDC_MODE: 'default',
  OIDC_CLIENT: __OIDC_CLIENT__,
  SENTRY_DSN: __SENTRY_DSN__,
  SENTRY_RELEASE: '0.0.0',
  SENTRY_ENVIRONMENT: 'dev',
  SENTRY_ENABLED: 'false'
}
